import axios from 'axios';
import { supabase } from './supabase';
import { appStateService } from './appState';

// IGNORANDO COMPLETAMENTE VARIÁVEIS DE AMBIENTE QUE NÃO ESTÃO FUNCIONANDO
// URL fixa do worker-proxy que sabemos que funciona
const WORKER_PROXY_URL = 'https://worker-proxy.smartbr.workers.dev';

// Log para debug
console.log('=== CONFIGURAÇÃO DA API ===');
console.log('Forçando uso do worker-proxy:', WORKER_PROXY_URL);
console.log('Ignorando variáveis de ambiente que não estão funcionando corretamente');

// Definindo baseURL diretamente como worker-proxy
const baseURL = WORKER_PROXY_URL;

const headers = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${process.env.AUTHORIZATION_TOKEN}`,
  'App-token': `Bearer ${process.env.APP_TOKEN}`
};

const api = axios.create({
  baseURL,
  timeout: 10000,
  headers,
  withCredentials: true  // Adicionado para suporte a CORS
});

// Log de configuração de credenciais
console.log('Configuração de Credenciais Axios:', {
  baseURL,
  withCredentials: api.defaults.withCredentials,
  credentialsAllowed: true,
  headersConfigured: Object.keys(headers).length > 0//,
  //authHeaderPresent: !!headers['Authorization'],
  //appTokenPresent: !!headers['App-token']
});

// Log de requisição
api.interceptors.request.use(request => {
  console.log('\n=== Enviando requisição ===');
  console.log('Base URL:', request.baseURL);
  console.log('URL completa:', request.url);
  console.log('Método:', request.method?.toUpperCase());
  // Headers removidos para evitar exposição de dados sensíveis
  console.log('Dados:', request.data);
  return request;
});

api.interceptors.response.use(
  response => {
    console.log('\n=== Resposta recebida ===');
    console.log('Status:', response.status);
    console.log('Data:', response.data);
    return response;
  },
  error => {
    console.error('\n=== Erro na requisição ===');
    console.error('Tipo de erro:', error.name);
    console.error('Código do erro:', error.code);
    console.error('Mensagem:', error.message);
    
    if (error.response) {
      console.error('Status do erro:', error.response.status);
      console.error('Dados do erro:', error.response.data);
    }
    
    return Promise.reject(error);
  }
);

// Configuração de bases de API
const API_BASES = {
  API: '/API',
  SYNC: '/update',
  REL: '/REL',
  sql: '/sql'  // Adicionado suporte para endpoint SQL
};



export const apiService = {
  // Método genérico para qualquer endpoint
  async request(
    base: keyof typeof API_BASES, 
    empresa: string, 
    endpoint: string, 
    method: 'get' | 'post' | 'put' | 'delete' = 'post', 
    data?: any
  ) {
    try {
      // Se os dados forem uma string, converte para objeto
      const requestData = typeof data === 'string' ? JSON.parse(data) : data;
      
      // Obter o token de acesso do Supabase
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;
      
      if (!token) {
        console.error('Usuário não autenticado. Faça login novamente.');
        throw new Error('Usuário não autenticado. Faça login novamente.');
      }
      
      // Obtém a rota da API do estado global
      let rota = appStateService.getApiRoute();
      
      // Se não encontrar a rota no estado global, busca no Supabase
      if (!rota) {
        console.warn('Rota da API não encontrada no estado global. Buscando no Supabase...');
        
        try {
          const { data: empresaData, error: empresaError } = await supabase
            .from('empresa')
            .select('rota')
            .eq('id', empresa)
            .single();

          if (empresaError) {
            console.error('Erro ao buscar rota da empresa:', empresaError);
            throw new Error(`Erro ao buscar rota da empresa: ${empresaError.message}`);
          }
          
          if (!empresaData?.rota) {
            console.error('Rota da API não encontrada para a empresa:', empresa);
            throw new Error(`Rota da API não encontrada para a empresa ${empresa}`);
          }
          
          rota = empresaData.rota;
          
          // Atualiza o estado global com a rota encontrada
          appStateService.updateUserData({ rotaApi: rota });
        } catch (error) {
          console.error('Erro ao buscar rota da API:', error);
          throw error;
        }
      }

      // Constrói o caminho relativo
      const relativePath = `${API_BASES[base]}/${rota}/${endpoint}`;
      
      // Constrói a URL absoluta usando o worker-proxy
      const absoluteUrl = `${WORKER_PROXY_URL}${relativePath}`;
      
      // Logs removidos por questões de segurança
      if (__DEV__) {
        console.log(`[API] ${method.toUpperCase()} ${endpoint}`);
        console.log('=== DETALHES DA REQUISIÇÃO ===');
        console.log('Base:', base);
        console.log('Empresa:', empresa);
        console.log('Endpoint:', endpoint);
        console.log('URL absoluta:', absoluteUrl);
        console.log('Dados processados:', requestData);
        // Headers removidos para evitar exposição de dados sensíveis
      }
      
      // Adiciona o token de autenticação aos headers
      const authHeaders = {
        ...headers,
        'Authorization': `Bearer ${token}`
      };
      
      console.log('Headers com token:', authHeaders);
      
      const response = await axios({
        method,
        url: absoluteUrl,
        data: method.toLowerCase() !== 'get' ? requestData : undefined,
        params: method.toLowerCase() === 'get' ? requestData : undefined, // Usar params para GET
        headers: authHeaders,
        withCredentials: true
      });
      
      console.log('=== RESPOSTA DA API ===');
      console.log('Status:', response.status);
      console.log('Data:', response.data);
      
      return response.data;
    } catch (error: any) {
      console.error('Erro detalhado na requisição:', {
        errorName: error.name,
        errorCode: error.code,
        errorMessage: error.message
      });
      throw error;
    }
  },

  // Métodos específicos com empresa dinâmica
  insertHistoricoCob: (data: any, empresa: string) => {
    console.log('=== PRIMEIRA REQUISIÇÃO (insertHistoricoCob) ===');
    console.log('Dados recebidos:', data);
    console.log('Empresa:', empresa);
    console.log('Endpoint:', 'FINANCEIROINSERTpchistcob');
    return apiService.request('SYNC', empresa, 'FINANCEIROINSERTpchistcob', 'post', data);
  },
  
  insertHistoricoCobi: (data: any, empresa: string) => {
    console.log('=== SEGUNDA REQUISIÇÃO (insertHistoricoCobi) ===');
    console.log('Dados recebidos:', data);
    console.log('Empresa:', empresa);
    console.log('Endpoint:', 'FINANCEIROINSERTpchistcobi');
    return apiService.request('SYNC', empresa, 'FINANCEIROINSERTpchistcobi', 'post', data);
  }
};

export default api;
